<template>
    <div>
        <div class="row card-body"> 
            <div class="col-12 pl-6 pr-6 pt-6">
                <v-list lines="one">
                    <v-list-item v-for="n in DocumentVotesList" :key="n" > 
                        {{ `${(selectedLang == 'ar' ? n.workflowVoteNameAr : n.workflowVoteName )} (${n.workflowVoteCount} ${n.voters})`}}
                    </v-list-item>
                </v-list> 

            <div class="p-3" v-show="DocumentVotesList == null || DocumentVotesList.length == 0">
                <p class="mb-3 text-primary font-weight-medium"> {{ $t('res_Label_VotesResultsEmptylbl')}} </p>
                <p> {{ $t('res_Label_VotesResultsEmptydesc')}}</p>
            </div> 

            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants'
    import axios from 'axios'

	export default {
		name: 'SeeVote',
		data() {
            return { 
                pinValue: '',
                validForm: false,
                canSignByImpersonation:false,
                SignAsOptions: [{ label: 'On behalf', value: false }, { label: 'Impersonation', value: true}],
                SelectedSignAsOption: false ,
                constants:constants,
                DocumentVotesList:[]
            };
        },
        props: {
            selectedLang: { type: String, required: false },
            documentId: { type: Number, required: false },
            transferId: { type: Number, required: false },
            delegationId: { type: Number, required: false },
            dialogModelShow: { type: Boolean, default: false },
        },
        methods:
        {
            
            getDocumentWorkFlowVotes(){
                window.showLoading();
                axios
					.get(
						constants.baseApiUrl +
							`Workflow/GetDocumentWorkFlowVotes?documentId=${this.documentId}&lang=${localStorage.getItem('lang')}`
					)
					.then((res) => {
                        this.DocumentVotesList = res.data
                        console.log('votes = ', res.data)
                        window.hideLoading();
					})
					.catch((err) => console.warn(err));
            },
            cancelDialog()
            {
                this.$emit('closeSeeVoteFormDialog');
            },
            resetForm()
            {
                this.pinValue = ''
                this.validForm = false
                this.canSignByImpersonation=false
                this.SelectedSignAsOption= false
            }
        },
        watch:
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    {
                      this.getDocumentWorkFlowVotes();
                    }
                    else
                        this.resetForm()
                }
            }
        },
        mounted: function ()
        {
            this.getDocumentWorkFlowVotes(); 
        }
	}
</script>